<template>
    <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card class="pa-2">
<!--      <v-toolbar-->
<!--        dark-->
<!--        :color="options.color"-->
<!--        dense-->
<!--        flat-->
<!--      >-->
<!--        <v-toolbar-title class="text-body-2 font-weight-bold grey&#45;&#45;text">-->
<!--          {{ title }}-->
<!--        </v-toolbar-title>-->
<!--      </v-toolbar>-->
      <v-img
        style="border-radius: 5px"
        height="150"
        src="@/assets/alert.jpg"
      ></v-img>
      <v-card-text
        v-show="!!message"
        class="pa-4 text-center px-0 black--text"
        v-html="message"
      />
      <v-card-actions class="pa-0">
        <v-btn
          color="primary"
          outlined
          @click.native="agree"
        >
          {{$t('yes')}}
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="!options.noconfirm"
          color="grey"
          outlined
          @click.native="cancel"
        >
          {{$t('cancel')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'Index',
    data: function () {
      return {
        dialog: false,
        resolve: null,
        reject: null,
        message: null,
        title: null,
        options: {
          color: 'grey lighten-3',
          width: 400,
          zIndex: 200,
          noconfirm: false,
        },
      }
    },
    methods: {
      open (title, message, options) {
        this.dialog = true
        this.title = title
        this.message = message
        this.options = Object.assign(this.options, options)
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      },
      agree () {
        this.resolve(true)
        this.dialog = false
      },
      cancel () {
        this.resolve(false)
        this.dialog = false
      },
    },
  }
</script>

<style scoped>

</style>
